import {FuseNavigationItem} from '../../../@fuse/components/navigation';
import {Navigation} from './navigation.types';

export const navigationMenu: FuseNavigationItem[] = [
    {
        type: 'divider',
        role: 'USER'
    },
    {
        id: 'dashboard',
        title: 'Strona Główna',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/dashboard',
        role: 'USER'
    },
    {
        id: 'vehicles',
        title: 'Pojazdy',
        type: 'basic',
        icon: 'heroicons_outline:rocket-launch',
        link: '/vehicles',
        role: 'USER'
    },
    {
        id: 'policies',
        title: 'Polisy',
        type: 'basic',
        icon: 'heroicons_outline:document-chart-bar',
        link: '/policies',
        role: 'USER'
    },
    {
        id: 'finances',
        title: 'Finansowe',
        type: 'basic',
        icon: 'heroicons_outline:currency-dollar',
        link: '/finances',
        role: 'USER'
    },
    {
        id: 'adminDashboard',
        title: 'Strona Główna',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/admin/dashboard',
        role: 'ADMIN'
    },
    {
        id: 'adminClients',
        title: 'Klienci',
        type: 'basic',
        icon: 'heroicons_outline:user',
        link: '/admin/clients',
        role: 'ADMIN'
    }
];

export const navigationItems: Navigation = {
    compact: navigationMenu,
    default: navigationMenu,
    futuristic: navigationMenu,
    horizontal: navigationMenu
};
